import { Box, TextField, Typography } from '@material-ui/core';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import React, { useState } from 'react';
import { ITabContentProps } from '../configuration';
import ProductFilterActions from '../store/actions';
import * as ProductFilterSelections from '../store/selectors';
import { PropertyFilterType } from '../configuration';
import { useDispatch } from 'react-redux';
import { isObjectNullish } from 'utils/objects';
import { useSelectLanguageID } from 'redux/reducers/gl_translations_reducer/selectors';
import UncontrolledSelectField from 'components/atoms/UncontrolledSelectField';

const TabLocations = (props: ITabContentProps) => {
  const dispatch = useDispatch();
  const lan = useSelectLanguageID();
  const city = ProductFilterSelections.useGetCity();
  const municipality = ProductFilterSelections.useGetMunicipality();

  React.useEffect(() => {
    dispatch(ProductFilterActions.fetchCity(lan));
    dispatch(ProductFilterActions.fetchMunicipality(lan));
  }, [dispatch, lan]);

  const onValueChange = (key: string, value: Array<string | number>) => {
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.Location]: {
          ...props.selections[PropertyFilterType.Location],
          isChecked:
            props.selections[PropertyFilterType.Location].data?.location?.city
              ?.length > 0 ||
            props.selections[PropertyFilterType.Location].data?.location
              ?.municipality?.length > 0,
          data: {
            location: {
              ...props.selections[PropertyFilterType.Location].data.location,
              [key]: value,
            },
          },
        },
      })
    );
  };

  return (
    <Box>
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '12px',
        }}
      >
        <TranslatedTextV2 translationKey={''} defaultText={'Locations'} />
      </Typography>
      <UncontrolledSelectField
        label={{ translationKey: '', defaultText: 'City' }}
        options={city ?? []}
        onValueChange={(value) => onValueChange('city', value as Array<number>)}
        field={'city'}
        value={
          props.selections[PropertyFilterType.Location].data.location.city ?? []
        }
        isMulti
        menuPortalTarget={null}
      />
      <Box marginBottom={'12px'}></Box>
      <UncontrolledSelectField
        label={{ translationKey: '', defaultText: 'Municipality' }}
        options={municipality ?? []}
        onValueChange={(value) =>
          onValueChange('municipality', value as Array<number>)
        }
        field={'municipality'}
        value={
          props.selections[PropertyFilterType.Location].data.location
            .municipality ?? []
        }
        isMulti
        menuPortalTarget={null}
      />
    </Box>
  );
};

export default TabLocations;
